import { render, staticRenderFns } from "./TransferOnDemandButton.vue?vue&type=template&id=1073c33f&scoped=true"
import script from "./TransferOnDemandButton.vue?vue&type=script&lang=ts"
export * from "./TransferOnDemandButton.vue?vue&type=script&lang=ts"
import style0 from "./TransferOnDemandButton.vue?vue&type=style&index=0&id=1073c33f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1073c33f",
  null
  
)

export default component.exports